/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NexonAnalyticsHolderRequest = {
    period: NexonAnalyticsHolderRequest.period;
    from?: string;
    to?: string;
};

export namespace NexonAnalyticsHolderRequest {

    export enum period {
        D7 = 'D7',
        M1 = 'M1',
        M6 = 'M6',
        YTD = 'YTD',
        Y1 = 'Y1',
        ALL = 'ALL',
    }


}

